import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {WpService} from '../../../../services/wp.service';
import {UrlBuilderService} from '../../../../services/url-builder.service';
import {WPPostNative} from '../../../../types/WPPostNative';
import {ToolsService} from '../../../../services/tools.service';

@Component({
  selector: 'app-native-list-post',
  templateUrl: './native-list-post.component.html',
  styleUrls: ['./native-list-post.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NativeListPostComponent implements OnInit {
  @Input() post: WPPostNative;
  @Input() index: number;
  public routePath: string[];
  public publishDate: string;
  public titleCssClass: string;
  public btnCssClass: string;

  constructor(
    private wpService: WpService,
    private urlBuilder: UrlBuilderService,
    private tools: ToolsService,
  ) {}

  ngOnInit() {
    this.createNativeUrl();
    this.publishDate = this.wpService.getFormattedDate(this.post.date);
    this.setElCssClasses();
  }

  private createNativeUrl(): void {
    this.routePath = this.post.acf.redirectedToUrl
      ? this.urlBuilder.convertRelativeUrlToRouterLink(this.post.acf.redirectedToUrl)[0]
      : this.urlBuilder.CreateNativePostRouterLink(this.post.id, this.post.slug);
  }

  private setElCssClasses(): void {
    this.btnCssClass = !this.tools.isNil(this.index)
      ? `test-native-article-morebtn-${this.index}`
      : `test-native-article-morebtn`;
    this.titleCssClass = !this.tools.isNil(this.index)
      ? `test-native-article-title-${this.index}`
      : `test-native-article-title`;
  }
}
